module.exports = __webpack_public_path__ + "static/media/17UN-Women1.b80d3ae2.jpg";